export default __webpack_public_path__ + "static/media/Icon-Projects.0657064d.svg";